// import React from "react";
// import { Link } from "react-router-dom";
// import { formatPrice } from "../../utils/helpers";
// import "./Product.scss";

// const Product = ({ product }) => {
//   return (
//     <Link to={`/product/${product?.id}`} key={product?.id}>
//       <div className="product-item bg-white">
//         <div className="category">{product?.category}</div>
//         <div className="product-item-img">
//           <img
//             className="img-cover"
//             src={product?.images[0]}
//             alt={product.title}
//           />
//         </div>
//         <div className="product-item-info fs-14">
//           <div className="brand">
//             <span>Brand: </span>
//             <span className="fw-7">{product?.brand}</span>
//           </div>
//           <div className="title py-2">{product?.title}</div>
//           <div className="price flex align-center justify-center">
//             {/* <span className="old-price">{formatPrice(product?.price)}</span> */}
//             <span className="new-price">{formatPrice(product?.price)}</span>
//             {/* <span className="new-price">
//               {formatPrice(product?.discountedPrice)}
//             </span> */}
//             {/* <span className="discount fw-6">
//               {product?.discountedPercentage}
//             </span> */}
//           </div>
//         </div>
//       </div>
//     </Link>
//   );
// };

// export default Product;

import React from "react";
import { Link } from "react-router-dom";
import { formatPrice } from "../../utils/helpers";
import "./Product.scss";
import { IMAGE_URL1 } from "../../utils/apiURL";


const ProductCategory = ({ product }) => {

  
  return (
    <Link to={`/vendor/category/${product.id}`}>
      <div className="product-item bg-white">
        <div className="category">{product.categorie_name}</div>
        <div className="product-item-img">
          <img
            className="img-cover"
            src={`${IMAGE_URL1}${product.product_images1}`} // Correction de la syntaxe pour l'URL de l'image
            alt={product.product_name} // Utilisation du nom du produit pour l'attribut alt
          />
        </div>
        <div className="product-item-info fs-14">
          <div className="brand">
            <span>Remaining Stock: </span>
            <span className="fw-7">{product.stock}</span> {/* Afficher l'ID du vendeur comme exemple */}
          </div>
          <div className="title py-2">{product.product_name}</div>
          <div className="price flex align-center justify-center">
            <span className="new-price">{formatPrice(product.price)}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCategory;